<div class="hero-dark"></div>
<div class="container">
  <div
    class="flex flex-column md:flex-row align-items-center md:justify-content-between"
  >
    <div class="my-2">
      <div class="flex align-items-center gap-2">
        <h1>Crea una donazione</h1>
        <img src="assets/media/icons/airplane.png" height="40" />
      </div>
      <h3 class="mt-0">
        Inserisci i dati per effettuare una
        <span class="green">donazione</span>!
      </h3>
    </div>
    <div class="screen breadcrumb-container flex align-items-center">
      <p-breadcrumb [model]="items" />
    </div>
  </div>
  <div
    class="flex align-items-center justify-content-between md:justify-content-center"
  ></div>
  <div class="container mb-6 container mb-6 border-200 border-1 border-round-lg md:p-4">
    <form [formGroup]="frmJoin">
      <div class="mt-3">
        <div class="flex align-items-center gap-2">
          <p-inputSwitch formControlName="anonymous" inputId="anonymous" />
          <label for="anonymous" class="text-sm mb-1"
            >Effettua una donazione anonima</label
          >
        </div>
      </div>
      @if(frmJoin.get('anonymous')?.value){
      <div class="mt-3">
        <span class="yellow text-xs"
          >* I dati sono richiesti solo per la pratica, ma la donazione resterà
          anonima e il nome non sarà mai visibile sul sito.</span
        >
      </div>
      }
      <div class="mt-5 form-section mb-4">
        <strong>Dati dell'intestatario pratica</strong>
        <div class="grid mt-3">
          <div class="col-12 md:col-4">
            <label>* Nome</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_name"
            />
            @if(frmJoin.get('accountholder_name')?.errors &&
            frmJoin.get('accountholder_name')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_name')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* Cognome</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_last_name"
            />
            @if(frmJoin.get('accountholder_last_name')?.errors &&
            frmJoin.get('accountholder_last_name')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_last_name')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* Codice fiscale</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_fiscal_code"
            />
            @if(frmJoin.get('accountholder_fiscal_code')?.errors &&
            frmJoin.get('accountholder_fiscal_code')?.dirty){
            <st-errors
              [errors]="frmJoin.get('accountholder_fiscal_code')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* Nazione di nascita</label>
            <div class="mt-1">
              <p-autoComplete
                [forceSelection]="true"
                [suggestions]="suggestedCountries"
                (completeMethod)="filterCountries($event)"
                field="name"
                dataKey="ISO"
                class="frm mt-1"
                [emptyMessage]="'Nessun risultato trovato'"
                emptyFilterMessage="Nessun risultato trovato"
                formControlName="accountholder_country_iso"
              >
              </p-autoComplete>
              @if(frmJoin.get('accountholder_country_iso')?.errors &&
              frmJoin.get('accountholder_country_iso')?.touched){
              <st-errors
                [errors]="frmJoin.get('accountholder_country_iso')?.errors"
              ></st-errors>
              }
            </div>
          </div>
          <div class="col-12 md:col-4">
            <label>* Indirizzo</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_address"
            />
            @if(frmJoin.get('accountholder_address')?.errors &&
            frmJoin.get('accountholder_address')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_address')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* CAP</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_zip_code"
            />
            @if(frmJoin.get('accountholder_zip_code')?.errors &&
            frmJoin.get('accountholder_zip_code')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_zip_code')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* Città</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_city"
            />
            @if(frmJoin.get('accountholder_cityv')?.errors &&
            frmJoin.get('accountholder_city')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_cityv')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* Provincia</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_province"
            />
            @if(frmJoin.get('accountholder_province')?.errors &&
            frmJoin.get('accountholder_province')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_provincev')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-4">
            <label>* Telefono</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_mobile_phone"
            />
            @if(frmJoin.get('accountholder_mobile_phone')?.errors &&
            frmJoin.get('accountholder_mobile_phone')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_mobile_phone')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-6">
            <label>* Email</label>
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="accountholder_email"
            />
            @if(frmJoin.get('accountholder_email')?.errors &&
            frmJoin.get('accountholder_email')?.touched){
            <st-errors
              [errors]="frmJoin.get('accountholder_email')?.errors"
            ></st-errors>
            }
          </div>
          <div class="col-12 md:col-6">
            <label
              [ngClass]="
                frmJoin.get('confirm_email')?.enabled ? '' : 'disabled'
              "
              >Conferma email</label
            >
            <input
              type="text"
              pInputText
              class="w-full mt-1"
              formControlName="confirm_email"
            />
            @if(frmJoin.get('confirm_email')?.enabled &&
            frmJoin.get('accountholder_email')?.value !==
            frmJoin.get('confirm_email')?.value){
            <div>
              <small class="form-danger">Le email non coincidono</small>
            </div>
            }
          </div>
        </div>

        <div class="grid">
          <div class="col-12 mt-4">
            <div class="amount-selector">
              <strong class="">Seleziona l'importo della donazione</strong>
              <p-inputNumber
              inputId="amount"
                class="w-full mt-3"
                mode="currency"
                currency="EUR"
                locale="it-IT"
                [min]="50"
                [step]="1"
                [formControl]="amount"
              ></p-inputNumber>
            </div>
          </div>

          <div class="col-12 m-0">
            @if((amount.value ?? 0) <= 49){
            <div>
              <span class="yellow text-xs">* Il valore minimo è 50.</span>
            </div>
            } @if((amount.value ?? 0) >= 50){
            <div class="flex flex-column">
              <strong>Importo selezionato</strong>
              <small class="grey-text">
                Paga in sicurezza con Stripe: utilizza la tua carta di credito o
                debito, oppure effettua un bonifico SEPA.
              </small>
              <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <h3 class="yellow m-0">
                  {{ amount.value | currency : "EUR" : "symbol" : ".2-2" }}
                </h3>
              </div>
            </div>
            <div class="flex align-items-center justify-content-center">
              <p-button
                label="Vai al pagamento"
                size="small"
                styleClass="slide px-6"
                (click)="submit()"
                [loading]="loading"
                [disabled]="frmJoin.invalid || amount.invalid"
              ></p-button>
            </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
